(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp_size-range-control"] && !Shopify.designMode) return;
  try {
    const details = document.getElementsByClassName('sr_details')[0];
  if (!details) return;
  const { width } = details.getBoundingClientRect();
  details.style.maxWidth = `0`;

  const pill = document.getElementsByClassName('sr_pill')[0];
  let showing = false;
  pill.addEventListener('click', () => {
    pill.classList.toggle('sr_active');
    showing = !showing;

    if (showing) {
      details.style.maxWidth = `${width}px`;
    } else {
      details.style.maxWidth = `0`;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
